import React from 'react';
import VDCConsumptionSubTable from './SubTable';
import VMTable from 'Pages/Assets/CloudCore/Consumption/VMTable';

const SubComponent = ({ row, filters, vdcs, columns, showVMs = false }) => {
  if (showVMs) {
    return <VMTable {...{ vms: row.original.vms, showLocation: false }} />;
  }

  return <VDCConsumptionSubTable {...{ row, filters, vdcs, columns }} />;
};

export default SubComponent
